import { StyleSheet } from 'react-native';
import { CornerRadius } from 'src/theme-v2/corner-radius';
import { getBoxShadow } from 'src/helpers/style.helper';
import { Neutrals } from 'src/theme-v2/colors';
import { Background } from 'src/theme-v2/background';

export const styles = StyleSheet.create({
  badge: {
    width: 34,
    height: 34,
    backgroundColor: Background.BackgroundColorDefault,
    borderRadius: CornerRadius.Full,
    justifyContent: 'center',
    alignItems: 'center',
    ...getBoxShadow({
      color: Neutrals.main.Black,
      opacity: 0.05,
      offsetY: 4,
      offsetX: 0,
      blurRadius: 10,
    }),
  },
  iconAlert: {
    width: 14,
    height: 14,
  },
});
